export const SEVERITY_COLOR = {
  G: "#1c8849ff",
  Y: "#d4ad10ff",
  R: "#921f15ff",
};

export const getStatusColor = (status) => {
  if (!status || typeof status !== "string" || status.length < 2) {
    return "#bdc3c7";
  }

  return SEVERITY_COLOR[status[1].toUpperCase()] ?? "#bdc3c7";
};
